
import React from 'react';
const Copyright = () => {

    return (
        <p style={{ fontSize: 14 }}>Copyright &copy; {new Date().getFullYear()} DATA E</p>
    )
}

export default Copyright;